import { render, staticRenderFns } from "./listturtles.vue?vue&type=template&id=bc5ce2a8&scoped=true"
import script from "./listturtles.vue?vue&type=script&lang=js"
export * from "./listturtles.vue?vue&type=script&lang=js"
import style0 from "./listturtles.vue?vue&type=style&index=0&id=bc5ce2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5ce2a8",
  null
  
)

export default component.exports